import { render } from "./VUEPopupNomeModulo.vue?vue&type=template&id=1d2d162a"
import script from "./VUEPopupNomeModulo.vue?vue&type=script&lang=js"
export * from "./VUEPopupNomeModulo.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__